/** Mirrors the backend's ReportKeys.normalize: UPPER_SNAKE_CASE, so "cashbook-payment" and
 *  "Cashbook Payment" both become CASHBOOK_PAYMENT. While typing, a trailing underscore is kept
 *  (pass keepTrailing) so "CASHBOOK " -> "CASHBOOK_" doesn't fight the person mid-word. */
export function normalizeReportKey(raw: string, keepTrailing = false): string {
  const key = raw
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, "_")
    .replace(/^_+/, "");
  return keepTrailing ? key : key.replace(/_+$/, "");
}
